import * as Yup from "yup";
import TextField from "../../../../common/components/formFields/TextField";
import Select from "../../../../common/components/formFields/Select";

export function formFields(t, values) {
  // console.log("_ values: %o", values);
  return [
    {
      size: 12,
      field: (
        <Select
          id="type"
          label={t("structure.SensorForm.form.type")}
          required={true}
          options={[
            {
              value: "TEMPERATURE",
              text: t("common.enum.sensorType.TEMPERATURE"),
            },
            { value: "HUMIDITY", text: t("common.enum.sensorType.HUMIDITY") },
            { value: "RELAY", text: t("common.enum.sensorType.RELAY") },
            { value: "BATTERY", text: t("common.enum.sensorType.BATTERY") },
            { value: "WATERLEVEL", text: t("common.enum.sensorType.WATERLEVEL") },
          ]}
        />
      ),
    },
    {
      size: 12,
      field: <TextField id="code" type="text" label={t("structure.SensorForm.form.code")} />,
    },
    {
      size: 12,
      field: (
        <TextField id="designation" type="text" label={t("structure.SensorForm.form.designation")} required={true} />
      ),
    },
    {
      size: 12,
      field: <TextField id="description" type="text" label={t("structure.SensorForm.form.description")} />,
    },
    {
      size: 12,
      field: <TextField id="model" type="text" label={t("structure.SensorForm.form.model")} />,
    },
    {
      size: 12,
      field: <TextField id="config.offset" type="text" label={t("structure.SensorForm.form.offset")} />,
      hidden: Boolean(values?.type !== "TEMPERATURE" && values?.type !== "HUMIDITY"),
    },
    {
      size: 12,
      field: <TextField id="config.waterTop" type="text" label={t("structure.SensorForm.form.waterTop")} />,
      hidden: Boolean(values?.type !== "WATERLEVEL"),
    },
    {
      size: 12,
      field: <TextField id="config.waterBottom" type="text" label={t("structure.SensorForm.form.waterBottom")} />,
      hidden: Boolean(values?.type !== "WATERLEVEL"),
    },
    {
      size: 12,
      field: <TextField id="config.voltageFull" type="text" label={t("structure.SensorForm.form.voltageFull")} />,
      hidden: Boolean(values?.type !== "BATTERY"),
    },
    {
      size: 12,
      field: <TextField id="config.voltageEmpty" type="text" label={t("structure.SensorForm.form.voltageEmpty")} />,
      hidden: Boolean(values?.type !== "BATTERY"),
    },
  ];
}

export function formSchema(t) {
  return Yup.object().shape({
    designation: Yup.string().required(t("structure.SensorForm.form.requiredDesignation")),
    description: Yup.string(),
    type: Yup.string().required(t("structure.SensorForm.form.requiredType")),
  });
}
